<template>
    <div class="bg-white pa-4 rounded-lg h-100 overflow-y-auto">
        <v-row class="my-0 h-md-100" justify="center" justify-md="start">
            <v-col class="h-100" md="4" sm="8" cols="12">
                <div class="rounded pa-4 h-100" style="background-color: #f0f5fa">
                    <h5 class="font-weight-bold text-primary mb-4">انتخاب فیلدهای سفارشی</h5>
                    <div style="overflow-y: auto; height: calc(100% - 36px);">
                        <v-row v-for="(item, type) in $system.customfieldTypes" :key="type" @click="addCustomField(type)" align="center" class="mx-0 my-2 cursor-pointer bg-white rounded department-customFields-chooseCards">
                            <v-col cols="auto">
                                <v-icon class="pa-4 rounded" color="primary" size="20" style="background-color: #cae2fe">{{ item.icon }}</v-icon>
                            </v-col>
                            <v-col class="text-grey-darken-1 font-weight-bold text-small">{{ item.name }}</v-col>
                            <v-col class="department-customFields-chooseCards-icon ms-auto" cols="auto">
                                <v-icon class="rounded pa-1" color="primary" size="24" style="background-color: #cae2fe4f">add</v-icon>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </v-col>
            <v-col class="h-100" md="8" cols="12">
                <p class="mb-4 text-small text-grey-darken-1">فیلدهای سفارشی ویژگی پرکاربردی در نرم افزار هلپیکال هستند که امکان دریافت اطلاعات بیشتری از کاربر در بخش های مختلفی از سامانه را امکان پذیر می سازند. برای تعریف فیلد های سفارشی، بر روی نوع فیلد دلخواه خود کلیک نمایید.<br> پس از تعریف فیلدهای سفارشی، امکان تعریف فرم های مختلفی شامل این فیلدها در بخش تنظیمات در اختیار شما قرار خواهد گرفت.</p>
                <p class="text-center font-weight-bold text-grey bg-grey-lighten-4 py-3 rounded mt-10 text-meta" v-if="!$system.customFields.length">موردی برای نمایش وجود ندارد.</p>
                <div class="px-2" style="overflow-y: auto; height: calc(100% - 110px);">
                    <div v-for="item in $system.customFields" :key="item.id">
                        <v-row dense align="center" class="my-2 mx-0 rounded pa-2 bg-white department-customFields-draggableCards">
                            <v-col cols="auto">
                                <v-icon color="primary" class="pa-4 rounded" style="background-color:#cae2fe">{{ $system.customfieldTypes[item.type].icon }}</v-icon>
                            </v-col>
                            <v-col cols="auto">
                                <p class="mb-0 text-small text-grey-darken-1 font-weight-bold user-select-none">{{ item.label }}</p>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="auto">
                                <v-btn @click="editCustomField(item)" class="rounded" color="secondary" variant="text" icon>
                                    <v-icon size="19">icon-edit</v-icon>
                                </v-btn>
                                <v-btn @click="removeCustomField(item)" class="rounded" color="error" variant="text" icon>
                                    <v-icon size="19">icon-trash</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </v-col>
        </v-row>
        <v-dialog v-model="dialog" width="400">
            <v-card tile>
                <v-toolbar color="white">
                    <v-toolbar-title class="text-primary">
                        <v-icon color="primary" class="pa-4 me-2 rounded" style="background-color:#cae2fe">{{$system.customfieldTypes[editForm.type].icon}}</v-icon>{{$system.customfieldTypes[editForm.type].name}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn @click="dialog = false" icon>
                        <v-icon color="primary" size="23">close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-form ref="form" @submit.prevent="$refs.form?.isValid ? submitDialog() : ''" class="px-7 pt-8">
                    <v-text-field
                        :rules="$validation('required')"
                        label="* برچسب"
                        v-model="editForm.label"
                    ></v-text-field>
                    <v-textarea
                        :rules="$validation('required')"
                        hint="هر مورد از گزینه‌ها را در یک خط وارد کنید"
                        persistent-hint
                        label="* گزینه ها"
                        no-resize
                        rows="3"
                        v-if="Object.hasOwn(editForm.options, 'items')"
                        v-model="editForm.options.items"
                    ></v-textarea>
                    <v-text-field
                        label="حداقل کاراکتر"
                        v-if="Object.hasOwn(editForm.options, 'min_length')"
                        v-model="editForm.options.min_length"
                    ></v-text-field>
                    <v-text-field
                        label="حداکثر کاراکتر"
                        v-if="Object.hasOwn(editForm.options, 'max_length')"
                        v-model="editForm.options.max_length"
                    ></v-text-field>
                    <v-text-field
                        label="حداقل مقدار"
                        v-if="Object.hasOwn(editForm.options, 'min')"
                        v-model="editForm.options.min"
                    ></v-text-field>
                    <v-text-field
                        label="حداکثر مقدار"
                        v-if="Object.hasOwn(editForm.options, 'max')"
                        v-model="editForm.options.max"
                    ></v-text-field>
                    <v-select
                        :items="[
                            { name: 'تاریخ', id: 'date' },
                            { name: 'زمان', id: 'time' },
                            { name: 'تاریخ و زمان',id: 'datetime'},
                        ]"
                        item-title="name"
                        item-value="id"
                        label="* تاریخ/زمان"
                        v-if="Object.hasOwn(editForm.options, 'type')"
                        v-model="editForm.options.type"
                    ></v-select>
                    <v-card-actions class="pb-4 px-5">
                        <v-btn type="submit" :loading="loading" variant="flat" color="success">ثبت اطلاعات</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn @click="dialog = false" color="error" variant="text">انصراف</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </div>
</template>


<script>
export default {
    title: "فیلد های سفارشی",
    validate(context) {
        return context.auth.user.full_admin && context.system.license.features.custom_field;
    },
    data() {
        return {
            loading: false,
            dialog: false,
            editForm: {label: null, type: 'text', options: {}},
        };
    },
    methods: {
        async submitDialog() {
            let form = JSON.parse(JSON.stringify(this.editForm));
            this.loading = true;
            if (Object.hasOwn(form, 'id'))
                await this.$customFieldUpdate(form.id, form).then(res => {
                    if (res && res.status == 'UPDATED')
                        this.$system.updateCustomField(form);
                });
            else
                await this.$customFieldStore(form).then(res => {
                    if (res && res.status == 'CREATED')
                        this.$system.pushCustomField({id: res.data.id, ...form});
                });
            this.loading = false;
            this.dialog = false;
        },
        async removeCustomField(item) {
            this.$confirm(
                `<p class="mb-0 font-weight-medium mt-2">آیا از انجام این عملیات اطمینان دارید؟</p><p class="text-small mb-0 mt-2">در صورت تایید، فیلد ${item.label} حذف خواهد شد.</p>`,
                { buttonTrueText: "حذف", buttonTrueColor: "error" }
            ).then((res) => {
                if (res){
                    this.$customFieldDelete(item.id).then(async res => {
                        if (res && res.status == 'DELETED')
                            this.$system.deleteCustomField(item);
                    });
                }
            });
        },
        addCustomField(type) {
            if (this.$refs.form)
                this.$refs.form.resetValidation();
            this.editForm = {label: null, type: type, options: {...this.$system.customfieldTypes[type].options}};
            this.dialog = true;
        },
        editCustomField(item) {
            if (this.$refs.form)
                this.$refs.form.resetValidation();
            this.editForm = JSON.parse(JSON.stringify(item));
            this.dialog = true;
        }
    },
};
</script>

<style lang="scss">
.department-customFields {
    &-draggableCards {
        box-shadow: 0 1px 5px transparent;
        outline: 1px solid rgba(128, 128, 128, 0.171);
        transition: all 0.3s;
        &:hover {
            box-shadow: 0 1px 10px #cae2fe;
            outline: 1px solid #cae2fe;
        }
    }
    &-chooseCards {
        box-shadow: 0 1px 5px transparent;
        &:hover {
            box-shadow: 0 1px 5px #cae2fe;
            outline: 1px solid #cae2fe;
        }
        &-icon {
            transition: all 0.3s;
            opacity: 0;
        }
        &:hover &-icon {
            opacity: 1;
        }
    }
}
</style>
